if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.productId = null;
      if (this.hasChildNodes()) this.init();

      // Écouter l'événement 'pageshow' pour rafraîchir le panier en cas de restauration depuis le cache
      /* window.addEventListener('pageshow', this.handlePageShow.bind(this)); */
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');
        this.submitBtnWasInitiallyDisabled = this.submitBtn.hasAttribute('disabled');
        this.provinceMessageEl = null;
        // this.checkoutBtn = document.querySelector('.proceed-to-checkout'); // Bouton pour procéder au paiement
        
        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        this.provinceDetectedHandler = this.provinceDetectedHandler || this.handleProvinceDetected.bind(this);
        document.addEventListener('on:province:detected', this.provinceDetectedHandler);
        this.handleProvinceDetected();
    
        // if (this.checkoutBtn) {
        //   this.checkoutBtn.addEventListener('click', this.handleCheckout.bind(this));
        // }
      }
    }

    disconnectedCallback() {
      if (this.provinceDetectedHandler) {
        document.removeEventListener('on:province:detected', this.provinceDetectedHandler);
      }
    }

    isOntarioVisitor() {
      return document.body.dataset.province === 'ON';
    }

    isOntarioEligibleProduct() {
      return this.dataset.ontarioEligible === 'true';
    }

    hasBothProvinceTags() {
      return this.dataset.ontarioEligible === 'true' && this.dataset.federalEligible === 'true';
    }

    shouldBlockByProvince() {
      if (!(theme.provinceFiltering && theme.provinceFiltering.enabled)) return false;
      if (!document.body.dataset.province) return false;
      if (this.hasBothProvinceTags()) return false;

      const isOntarioVisitor = this.isOntarioVisitor();
      const isOntarioEligible = this.isOntarioEligibleProduct();
      const block = isOntarioVisitor ? !isOntarioEligible : isOntarioEligible;
      if (theme.provinceFiltering?.enabled && document.body.dataset.province) {
        console.log('[ProductForm] shouldBlockByProvince', {
          province: document.body.dataset.province,
          isOntarioVisitor,
          isOntarioEligible,
          federalEligible: this.dataset.federalEligible === 'true',
          block
        });
      }
      return block;
    }

    getProvinceRestrictedMessage() {
      if (theme.provinceFiltering && theme.provinceFiltering.restrictedMessage) {
        return theme.provinceFiltering.restrictedMessage;
      }
      return 'This product is not available in your province.';
    }

    ensureProvinceMessageElement() {
      if (this.provinceMessageEl) return this.provinceMessageEl;

      const target = this.querySelector('.product-info__add-to-cart');
      if (!target) return null;

      const message = document.createElement('p');
      message.className = 'province-restriction-message';
      message.hidden = true;
      target.insertAdjacentElement('beforebegin', message);
      this.provinceMessageEl = message;
      return message;
    }

    showProvinceRestriction() {
      const message = this.ensureProvinceMessageElement();
      if (!message) return;
      message.textContent = this.getProvinceRestrictedMessage();
      message.hidden = false;
    }

    handleProvinceDetected() {
      if (!this.submitBtn) return;

      const block = this.shouldBlockByProvince();
      console.log('[ProductForm] handleProvinceDetected', { block });
      if (block) {
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.setAttribute('disabled', 'disabled');
        this.submitBtn.classList.add('is-disabled-by-province');
        this.showProvinceRestriction();
      } else {
        this.submitBtn.classList.remove('is-disabled-by-province');
        this.submitBtn.removeAttribute('aria-disabled');
        if (!this.submitBtnWasInitiallyDisabled) {
          this.submitBtn.removeAttribute('disabled');
        }
        if (this.provinceMessageEl) {
          this.provinceMessageEl.hidden = true;
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      if (this.shouldBlockByProvince()) {
        evt.preventDefault();
        this.showProvinceRestriction();
        return;
      }

      evt.preventDefault();
      console.log("handleSubmit !");

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      try {
        const formData = new FormData(this.form);
        const mainProductQuantity = parseInt(formData.get('quantity') || "1", 10);
        const mainProductId = formData.get('id');
        const taxInput = this.form.querySelector('#tax-id-input');
        let items = [];

        // Get current cart data early
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();


        // Add main product and its tax
        items.push({
          id: mainProductId,
          quantity: mainProductQuantity,
          properties: {
            _tax_variant_id: taxInput.value
          }
        });

        if (taxInput.value !== 'no_tax_product') {
          items.push({
            id: taxInput.value,
            quantity: mainProductQuantity,
            properties: {
              [window.theme.strings.taxForAttribute]: taxInput.dataset.productTitle,
              _tax_for: taxInput.dataset.productId
            }
          });
        }

                 // Check if this variant has companion products in pairsData
         const pairMatch = window.pairsData.find(pair => pair.target_variants.includes(Number(mainProductId)));
         console.log("🚀 ~ ProductForm ~ handleSubmit ~ pairMatch:", pairMatch);
         
         if (pairMatch && pairMatch.auto_add_variants) {
           // Get quantities of auto-add variants already in cart
           const cartQuantities = {};
           let totalAutoAddInCart = 0;
           
           cartData.items.forEach(item => {
             if (pairMatch.auto_add_variants.some(v => v.id === item.variant_id)) {
               cartQuantities[item.variant_id] = item.quantity;
               totalAutoAddInCart += item.quantity;
             }
           });

           // If auto_add_only_one_product is true and there's already a product in cart, skip adding
           if (pairMatch.auto_add_only_one_product && totalAutoAddInCart > 0) {
             console.log("🚀 ~ Auto-add product already in cart, skipping due to auto_add_only_one_product");
           } else {
             // Calculate available inventory by subtracting cart quantities
             const availableVariants = pairMatch.auto_add_variants
               .map(variant => ({
                 ...variant,
                 available_quantity: variant.inventory_quantity - (cartQuantities[variant.id] || 0)
               }))
               .filter(variant => variant.available_quantity > 0);

             let quantityToAdd;
             if (pairMatch.auto_add_only_one_product) {
               // Add only 1 product regardless of main product quantity
               quantityToAdd = 1;
             } else {
               // Add same quantity as main product
               quantityToAdd = mainProductQuantity;
             }

             let remainingQuantity = quantityToAdd;
             const addedVariants = [];
             let totalAdded = 0;

             for (const variant of availableVariants) {
               if (remainingQuantity <= 0) break;

               const variantQuantityToAdd = Math.min(remainingQuantity, variant.available_quantity);
               
               if (variantQuantityToAdd > 0) {
                 addedVariants.push({
                   id: String(variant.id),
                   quantity: variantQuantityToAdd,
                   properties: {
                     _tax_variant_id: String(pairMatch.auto_add_tax_variant)
                   }
                 });

                if (pairMatch.auto_add_tax_variant !== 'no_tax_product') {
                  addedVariants.push({
                    id: String(pairMatch.auto_add_tax_variant),
                    quantity: variantQuantityToAdd,
                    properties: {
                      [window.theme.strings.taxForAttribute]: pairMatch.auto_add_product_title,
                      _tax_for: String(pairMatch.auto_add_product_id)
                    }
                  });
                }

                 totalAdded += variantQuantityToAdd;
                 remainingQuantity -= variantQuantityToAdd;
               }
             }

             items.push(...addedVariants);
           }
         }

        // Add single market tax product once if on the configured market
        if (window.theme.settings.isUsTax) {
          const marketTaxVariantId = String(window.theme.settings.marketTaxesVariantId);
          const marketTaxInCart = cartData.items.some(
            item => item.variant_id.toString() === marketTaxVariantId
          );
          if (!marketTaxInCart) {
            items.push({ id: marketTaxVariantId, quantity: 1, properties: { _market_tax: 'true' } });
          }
        }

        // Check if shipping protection (Theme settings > Cart) is already in cart
        const shippingProtectionVariantId = String(window.theme.settings.shippingProtectionVariantId || '');
        const shippingProtectionInCart = cartData.items.some(
          item => item.variant_id.toString() === shippingProtectionVariantId
        );

        // Add shipping protection if configured and not in cart
        if (shippingProtectionVariantId && !shippingProtectionInCart) {
          items.push({
            id: shippingProtectionVariantId,
            quantity: 1
          });
        }

        console.warn("🚀 ~ ProductForm ~ handleSubmit ~ items:", items);

        // Prepare sections for cart update (cart icon + cart drawer section + inline progress bars on PDP)
        let sections = 'cart-icon-bubble';
        if (this.cartDrawer) {
          sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }
        const inlineProgressBars = document.getElementById('progress-bars-inline');
        console.log("🚀 ~ ProductForm ~ handleSubmit ~ inlineProgressBars:", inlineProgressBars)
        if (inlineProgressBars) {
          // const inlineSectionId = inlineProgressBars.closest('.shopify-section')?.id?.replace('shopify-section-', '');
          sections += `,${inlineProgressBars.dataset.section}`;
        }
        // if (inlineProgressBars) {
        //   sections += `,progress-bars-inline`;
        // }

        // Construct the request payload
        const payload = {
          items,
          sections_url: window.location.pathname,
          sections
        };

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        };

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        console.log("🚀 ~ ProductForm ~ handleSubmit ~ data:", data);

        if (!response.ok) throw new Error(response.status);

        if (window.theme.settings.isUsTax) {
          const cartResponse2 = await fetch(`${window.Shopify.routes.root}cart.js`);
          const cartData2 = await cartResponse2.json();
          const updatedCartData = await window.updateCartSubtotalAttribute(cartData2, {
            sections,
            sections_url: window.location.pathname
          });
          if (updatedCartData?.sections) {
            data.sections = { ...(data.sections || {}), ...updatedCartData.sections };
          }
        }

       

        if (theme.settings.afterAtc === 'page') {
          window.location.href = theme.routes.cart;
        } else {
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          if (this.cartDrawer) {
            this.cartDrawer.renderContents(
              data,
              !quickAddDrawer && theme.settings.afterAtc === 'drawer'
            ).then(() => {
              window.updateProductPageQuantity(data.variant_id);
            });
          }

          // If inline progress bars section exists on PDP, refresh it via returned sections
          console.log("🚀 ~ ProductForm ~ handleSubmit ~ data.sections:", data.sections)
          if (inlineProgressBars && data.sections) {
            const collectionBannerHTMLString = data.sections[inlineProgressBars.dataset.section];
            if (collectionBannerHTMLString) {
              inlineProgressBars.innerHTML = new DOMParser().parseFromString(collectionBannerHTMLString, 'text/html').body.querySelector('#progress-bars-inline').innerHTML;
            }
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}


